export const generateRandomKey = () => {
	let array = new Uint32Array(1);
	if (window.crypto && window.crypto.getRandomValues) {
		window.crypto.getRandomValues(array);
	} else {
		array[0] = Math.floor(Math.random() * 4294967296);
	}
	return array[0].toString(36);
};
